import { render, staticRenderFns } from "./printTemplateConfig.vue?vue&type=template&id=2d2da1b6"
import script from "./printTemplateConfig.vue?vue&type=script&lang=js"
export * from "./printTemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./printTemplateConfig.vue?vue&type=style&index=0&id=2d2da1b6&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2da1b6')) {
      api.createRecord('2d2da1b6', component.options)
    } else {
      api.reload('2d2da1b6', component.options)
    }
    module.hot.accept("./printTemplateConfig.vue?vue&type=template&id=2d2da1b6", function () {
      api.rerender('2d2da1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/printTemplateConfig.vue"
export default component.exports